/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimension } from './RiskDimension';
import { RiskDimensionFromJSON, RiskDimensionFromJSONTyped, RiskDimensionToJSON } from './RiskDimension';
import type { RiskDimensionLabel } from './RiskDimensionLabel';
import {
  RiskDimensionLabelFromJSON,
  RiskDimensionLabelFromJSONTyped,
  RiskDimensionLabelToJSON,
} from './RiskDimensionLabel';

/**
 *
 * @export
 * @interface RiskProfileDimensionRisk
 */
export interface RiskProfileDimensionRisk {
  /**
   *
   * @type {number}
   * @memberof RiskProfileDimensionRisk
   */
  readonly id: number;
  /**
   *
   * @type {RiskDimension}
   * @memberof RiskProfileDimensionRisk
   */
  readonly dimension: RiskDimension;
  /**
   *
   * @type {RiskDimensionLabel}
   * @memberof RiskProfileDimensionRisk
   */
  readonly calculatedRiskLabel: RiskDimensionLabel;
  /**
   *
   * @type {RiskDimensionLabel}
   * @memberof RiskProfileDimensionRisk
   */
  overrideRiskLabel?: RiskDimensionLabel;
}

/**
 * Check if a given object implements the RiskProfileDimensionRisk interface.
 */
export function instanceOfRiskProfileDimensionRisk(value: object): value is RiskProfileDimensionRisk {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('dimension' in value) || value['dimension'] === undefined) return false;
  if (!('calculatedRiskLabel' in value) || value['calculatedRiskLabel'] === undefined) return false;
  return true;
}

export function RiskProfileDimensionRiskFromJSON(json: any): RiskProfileDimensionRisk {
  return RiskProfileDimensionRiskFromJSONTyped(json, false);
}

export function RiskProfileDimensionRiskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskProfileDimensionRisk {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    dimension: RiskDimensionFromJSON(json['dimension']),
    calculatedRiskLabel: RiskDimensionLabelFromJSON(json['calculated_risk_label']),
    overrideRiskLabel:
      json['override_risk_label'] == null ? undefined : RiskDimensionLabelFromJSON(json['override_risk_label']),
  };
}

export function RiskProfileDimensionRiskToJSON(
  value?: Omit<RiskProfileDimensionRisk, 'id' | 'dimension' | 'calculatedRiskLabel'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    override_risk_label: RiskDimensionLabelToJSON(value['overrideRiskLabel']),
  };
}
